import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}`;

export default {
  // Employee-facing leaves list
  getMyLeaves(params = {}) {
    return axios.get(`${API_URL}employee/leaves`, { params, headers: buildHeaders() });
  },
  // Summary cards & per-type remaining days
  getMySummary(params = {}) {
    return axios.get(`${API_URL}employee/leaves/summary`, { params, headers: buildHeaders() });
  },
  colleagues() {
    return axios.get(`${API_URL}employee/leaves/colleagues`, { headers: buildHeaders() });
  },
  // Create/update/delete
  create(data) {
    return axios.post(`${API_URL}employee/leaves`, data, { headers: buildHeaders() });
  },
  update(id, data) {
    return axios.put(`${API_URL}employee/leaves/${id}`, data, { headers: buildHeaders() });
  },
  delete(id) {
    return axios.delete(`${API_URL}employee/leaves/${id}`, { headers: buildHeaders() });
  },
};
